exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rate{color:#fff;padding:5px;border-radius:5px}.rate.good{background-color:#43cb83}.rate.average{background-color:#f9b954}.rate.bad{background-color:#f57846}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-20cd74de!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/grid/CommentRatingHighlightComponent.vue
// module id = 853
// module chunks = 2